import { Component, input } from "@angular/core";
import { RouterLink } from "@angular/router";
import { BlogPostSummary, SECTION_LABELS } from "./blog.models";

/**
 * Card de artículo para los listados (home, secciones). Presentacional:
 * recibe un `BlogPostSummary` y enlaza a `/${section}/${slug}`.
 */
@Component({
  selector: "app-blog-card",
  imports: [RouterLink],
  template: `
    @let p = post();
    <a [routerLink]="['/', p.section, p.slug]" class="group block">
      <div class="overflow-hidden rounded-xl bg-bg-alt">
        <img
          [src]="p.heroImage.url"
          [alt]="p.heroImage.alt"
          loading="lazy"
          class="h-[350px] w-full object-cover transition duration-300 group-hover:scale-105"
        />
      </div>
      <p
        class="mt-3 text-xs font-semibold uppercase tracking-wide text-primary"
      >
        {{ sectionLabels[p.section] }}
      </p>
      <h3
        class="mt-1 font-semibold leading-snug text-fg transition group-hover:text-primary"
      >
        {{ p.title }}
      </h3>
      <p class="mt-1 line-clamp-2 text-sm leading-relaxed text-fg-muted">
        {{ p.excerpt }}
      </p>
      <p class="mt-2 text-xs text-fg-subtle">
        {{ p.publishedAt }} · {{ p.readingMinutes }} min
      </p>
    </a>
  `,
})
export class BlogCardComponent {
  readonly post = input.required<BlogPostSummary>();

  /**
   * Getter instead of class field: avoids a Vite SSR ssrTransform bug where
   * ESM cross-chunk import identifiers inside native class field initializers
   * are not rewritten to their __vite_ssr_import_N__ accessor form. Method
   * bodies (including getters) are correctly transformed. In production esbuild
   * inlines everything anyway, so there is no runtime cost difference.
   */
  protected get sectionLabels(): typeof SECTION_LABELS {
    return SECTION_LABELS;
  }
}
